import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { sendEventClick } from 'src/api/tracker';

import ApplyTo from 'src/components/ApplyTo/ApplyTo';
import { setApplyToImpressionsSent } from 'src/redux/actions/impressions';
import { setApplyToImpressions } from 'src/utils/analytics/applyTo';
import 'src/containers/ApplyToContainer.scss';

const ApplyToContainer = () => {
  const { employersList = [], hasApplyToImpressionBeenSent } = useSelector(
    ({ employers, impressions }) => ({
      employersList: employers.list,
      hasApplyToImpressionBeenSent: impressions.applyToImpressionSent,
    })
  );
  const dispatch = useDispatch();

  const handleEmployerClick = useCallback((index) => {
    sendEventClick('dailyspecials_empProfile', index);
  }, []);

  useEffect(() => {
    if (!hasApplyToImpressionBeenSent) {
      setApplyToImpressions(employersList);
      dispatch(setApplyToImpressionsSent(true));
    }
  }, [dispatch, hasApplyToImpressionBeenSent, employersList]);

  return (
    <div data-test="section-applyTo" styleName="apply-to-container">
      <ApplyTo
        employers={employersList}
        onEmployerClick={handleEmployerClick}
      />
    </div>
  );
};

export default ApplyToContainer;
